import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function IconFillvideo({
  className,
  width,
  height,
  color,
  hoverColor,
  viewBox,
}) {
  const [mainColor, setMainColor] = useState(color);

  useEffect(() => {
    if (color !== mainColor) {
      setMainColor(color);
    }
  }, [color]);

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox={viewBox}
      onMouseEnter={() => setMainColor(hoverColor)}
      onMouseLeave={() => setMainColor(color)}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3.8"
        y="5.8"
        width="16.4"
        height="12.4"
        rx="3.2"
        stroke={mainColor}
        strokeWidth="1.6"
      />
      <path d="m14.5 12-4 3V9l4 3z" fill={mainColor} />
    </svg>
  );
}

IconFillvideo.defaultProps = {
  className: undefined,
  width: 24,
  height: 24,
  color: '#BDBDBD',
  hoverColor: '#fff',
  viewBox: '0,0,24,24',
};

IconFillvideo.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  viewBox: PropTypes.string,
};

export default IconFillvideo;
